import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getBusinessData } from "../API/Coupons/BusinessData";
import SideBar from "../SideBar/SideBar";
import BackButton from "../BackButton/BackButton";
import {
  Col,
  Form,
  Image,
  InputGroup,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import FroalaEditorView from "react-froala-wysiwyg/FroalaEditorView";
import PrivacyTermsConditions from "../PrivacyTermsConditions/PrivacyTermsConditions";
import Loader from "../Loader/Loader";

const ViewBusiness = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const { mb_id } = useParams();
  const navigate = useNavigate();

  const getBusinessDetails = async () => {
    if (!mb_id) {
      return;
    }
    setLoading(true);
    const response = await getBusinessData(mb_id, () => {
      navigate("/");
    });
    if (response.success) {
      console.log("view-business",response)
      setData(response.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    getBusinessDetails();
  }, []);
  return (
    <div>
       {loading ? <Loader /> : ""}{" "}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <SideBar />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <BackButton />
          <p className="page-maintitle">View Business</p>

          <div className="acc-dashboard mt-4">
            <Form className="formmain mx-0 mt-2 signin-row profile-form pb-4">
              {/* Category & Business Name */}
              <Row className="mb-4">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      Category <span className="text-danger">*</span>
                    </Form.Label>
                    <InputGroup className="edit-border">
                      <Form.Control
                        type="text"
                        value={data?.category_name ? data?.category_name : ""}
                        disabled={true}
                      />
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      Business Name <span className="text-danger">*</span>
                    </Form.Label>
                    <InputGroup className="edit-border">
                      <Form.Control
                        type="text"
                        value={data?.business_name}
                        disabled={true}
                      />
                    </InputGroup>
                  </Form.Group>
                </Col>
              </Row>

              {/* Online URL */}
              <Row className="mb-4">
                <Col md={12}>
                  <Form.Group>
                    <Form.Label>Online URL</Form.Label>
                    <InputGroup className="edit-border">
                      <Form.Control
                        type="text"
                        value={data?.online_url ? data?.online_url : ""}
                        disabled={true}
                      />
                    </InputGroup>
                  </Form.Group>
                </Col>
              </Row>

              {/* Contact Details */}
              <Row className="mb-4">
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>
                      Contact Number <span className="text-danger">*</span>
                    </Form.Label>
                    <InputGroup className="edit-border">
                      <Form.Control
                        type="text"
                        value={data?.contact}
                        disabled={true}
                      />
                    </InputGroup>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>
                      Contact Email <span className="text-danger">*</span>
                    </Form.Label>
                    <InputGroup className="edit-border">
                      <Form.Control
                        type="email"
                        value={data?.primary_email}
                        disabled={true}
                      />
                    </InputGroup>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Secondary Email</Form.Label>
                    <InputGroup className="edit-border">
                      <Form.Control
                        type="email"
                        value={data?.secondary_email ?  data?.secondary_email : ""}
                        disabled={true}
                        autoComplete="off"
                      />
                    </InputGroup>
                  </Form.Group>
                </Col>
              </Row>

              {/* Business Description */}
              <Row className="mb-4 desc_terms_condition">
                <Col md={12}>
                  <Form.Group>
                    <Form.Label>
                      Business Description{" "}
                      <span className="text-danger">*</span>
                    </Form.Label>

                    <FroalaEditorView model={data?.description} />
                  </Form.Group>
                </Col>
              </Row>
              {/* Buttons */}
            </Form>
          </div>
        </div>
      </div>
      <PrivacyTermsConditions />
    </div>
  );
};

export default ViewBusiness;
